import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';
import { useWindowScroll, useWindowSize } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppUpButton',
  setup(__props) {

const { y: yScroll } = useWindowScroll();
const { height: windowHeight } = useWindowSize();
const isButtonShowed = computed(() => yScroll.value >= windowHeight.value);
const handleClick = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
};

return { __sfc: true,yScroll, windowHeight, isButtonShowed, handleClick }
}

})